module.exports = __webpack_public_path__ + "img/HPS024NG.deb5d3ca.png";